import { Component, OnInit } from '@angular/core';
import { ProductsService } from 'src/app/products.service';
import { CartService } from 'src/app/cart.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-cart',
  templateUrl: './cart.component.html',
  styleUrls: ['./cart.component.css']
})
export class CartComponent implements OnInit {
  cartDetails;
  totalPrice: number = 0;
  productIds: string[] = [];
  quantities: string[] = [];
  orderId: number;
  constructor(private productService: ProductsService, private cartService: CartService, private router: Router) { }

  ngOnInit(): void {
    this.getProductsInCart();

  }
  removeFromCart(id: number) {
    let product = {
      product_id: id
    }
    this.productService.removeProductFromCart(product).subscribe(
      (result) => {

        this.getProductsInCart();
        this.getTotalPrice()
      }
    )

  }
  increase(value) {
    value.quantity += 1

    this.getTotalPrice()
  }

  decrease(value) {
    if (value.quantity > 1) {

      value.quantity -= 1;
      this.getTotalPrice()
    }

    // console.log(this.counter)
  }
  getTotalPrice() {
    this.totalPrice = this.cartDetails.order_details.reduce(function (total, currentValue, currentIndex, arr) {
      return total + (currentValue.quantity * currentValue.price)
    }, 0)
  }
  getProductsInCart() {
    this.productService.getProductsInCart().subscribe(
      (result) => {
        console.log(result)
        this.cartDetails = result;
        this.orderId = result.id
        this.getTotalPrice();


      }
    )
  }

  orderSet() {
    this.productIds = [];
    this.quantities = [];
    let ids: string = this.productIds + ""
    for (let i = 0; i < this.cartDetails.order_details.length; i++) {
      this.productIds.push(this.cartDetails.order_details[i].product_id);
      this.quantities.push(this.cartDetails.order_details[i].quantity);
    }
    let order = {
      product_ids: this.productIds.toString(),
      quantities: this.quantities.toString()
    }


    this.cartService.setOrder(this.orderId, order).subscribe(
      (result) => {
        console.log(result)
        this.router.navigate(['/address',this.orderId])
      }
    )
  }
}
